export { default } from './our-goal';
